<script lang="ts">
  import { cn } from '@shared/utils';

  import { ArtAssetSearchCard } from '@entities/art-asset';
  import { ArtistSearchCard } from '@entities/artist';
  import type { SearchData } from '@entities/search';
  import { SelectionSearchCard } from '@entities/selection';

  import ListLabel from './list-label.svelte';

  export let artworks: SearchData['artworks'] | null;
  export let artists: SearchData['artists'] | null;
  export let selections: SearchData['selections'] | null;
  export let search: string;

  $: entityCount = [artworks, artists, selections].filter((ds) => ds && ds?.data.length > 0).length;

  function getGridCols(count: number) {
    switch (count) {
      case 1:
        return 'md:grid-cols-1';
      case 2:
        return 'md:grid-cols-2';
      case 3:
        return 'md:grid-cols-2 xl:grid-cols-3';
      default:
        return '';
    }
  }
</script>

<div class="{cn('grid w-full gap-5', getGridCols(entityCount))}">
  {#if artworks?.data.length}
    <section>
      <div class="mb-5">
        <ListLabel
          label="Artworks"
          count="{artworks.totalCount}"
          href="/search/artworks/?search={search}"
          on:navigate
        />
      </div>

      <div class="grid gap-2">
        {#each artworks.data as artwork}
          <ArtAssetSearchCard
            image="{artwork.image}"
            artist="{artwork.artist}"
            slug="{artwork.slug}"
            name="{artwork.name}"
            year="{artwork.year}"
            isImageBlurred="{!!artwork.contentFlags.length}"
            on:navigate
          />
        {/each}
      </div>
    </section>
  {/if}

  {#if artists?.data.length}
    <section>
      <div class="mb-5">
        <ListLabel label="Artists" count="{artists.totalCount}" href="/search/artists/?search={search}" on:navigate />
      </div>

      <div class="grid gap-2">
        {#each artists.data as artist}
          <ArtistSearchCard
            id="{artist.id}"
            photo="{artist.photo}"
            slug="{artist.slug}"
            name="{artist.name}"
            artAssetsCount="{artist.artAssetsCount}"
            on:navigate
          />
        {/each}
      </div>
    </section>
  {/if}

  {#if selections?.data.length}
    <section
      class="{cn({
        'md:col-span-2 xl:col-span-1': artists?.data.length && artworks?.data.length,
      })}"
    >
      <div class="mb-5">
        <ListLabel
          label="Selections"
          count="{selections.totalCount}"
          href="/search/selections/?search={search}"
          on:navigate
        />
      </div>

      <div class="grid gap-2">
        {#each selections.data as selection}
          <SelectionSearchCard item="{selection}" totalCount="{selections.totalCount}" on:navigate />
        {/each}
      </div>
    </section>
  {/if}
</div>
